module.exports = __webpack_public_path__ + "static/media/MobileOfficePro.fb4cb761.png";